/** スライダーに関する定数一覧 */

export const SliderConstant = {
  SpMaxWidth: "767px", // SP表示の最大サイズ
}
